import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import Promise from 'bluebird'
import R from 'ramda'
import styled from 'styled-components'
import { Colors, Metrics, Fonts } from '../../Themes'
import SearchDropdown from './SearchDropdown'
import MoreFilters from './MoreFilters'
import RangePicker from '../RangePicker'
import Button from '../Button'
import SearchableDropdown from '../SearchableDropdown'
import MultiSelectDropdown from '../MultiSelectDropdown'
import {
  searchCategories,
  searchContinents,
  searchCountries,
  searchCities
} from '../../sources/SearchSource'
import { addOrRemoveObjectFromList } from '../../Utils'
import MobileSearchBar from './MobileSearchbar'
import {
  maxPrice,
  maxYield,
  maxRooms,
  defaultPriceStep,
  defaultRoomsStep,
  defaultYieldStep
} from '../../Utils/Constants'
import Dropdown from '../Dropdown'
import { searchQueryDefault } from '../../Utils/Defaults'

const SearchBarContainer = styled.div`
  width: 100%;
  height: ${Metrics.components.searchbar};
  background-color: ${Colors.white};
  border: ${Metrics.borders.default};
  position: absolute;
  top: calc(${Metrics.components.navbarDefault} - 1px);
  z-index: 2;

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: ${props => (props.isAdmin ? 'block' : 'none')};
  }
`

const Container = styled.div``

const ActionsContainer = styled.div`
  display: inline-block;
  position: absolute;
  top: ${Metrics.margins.medium};
`

const ExportInfo = styled(Button)`
  margin-left: ${Metrics.margins.small};
  padding: 8px ${Metrics.margins.small};
`

const Title = styled.div`
  ${Fonts.style.Label};
  margin-bottom: ${Metrics.margins.small};
`

const Form = styled.div`margin-bottom: ${Metrics.margins.base};`

const CustomMultiSelect = styled(MultiSelectDropdown)`
  .arrow {
    display: none;
  }

  .dropdown-component {
    border: none;
  }

  .dropdown-list {
    border: none;
    position: static;
    display: block;

    .list {
      display: block;
    }
  }
`

const CustomDropdown = styled(Dropdown)`
  border: none;
  .arrow {
    display: none;
  }

  .dropdown-list {
    border: none;
    position: static;
    display: block;
    padding: ${Metrics.margins.small};

    .list {
      display: block;
    }
  }
`

const CustomSearchableDropdown = styled(SearchableDropdown)`
  .dropdown-list {
    position: static;
    margin-top: -10px;
  }

  input {
    padding: 0;
  }
`

const CustomRangePicker = styled(RangePicker)`
  .picker {
    margin-left: 5px;
  }
`

const ButtonContainer = styled.div`
  float: right;
  ${props => (props.noPadding ? 0 : `padding: ${Metrics.margins.small}`)};
  padding-top: ${Metrics.margins.small};
`

class SearchBar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      active: '',
      settings: props.settings,
      searchCountry: '',
      searchContinent: '',
      searchCity: '',
      countries: [],
      categories: [],
      continents: [],
      cities: [],
      portfolio: null,
      favorites: null,
      openModal: false,
      selectedRequest: null,
      searchRequests: props.searchRequests || null
    }
    this.handleDropdownClick = this.handleDropdownClick.bind(this)
    this.handleOnBlur = this.handleOnBlur.bind(this)
    this.handleOnFocus = this.handleOnFocus.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleRange = this.handleRange.bind(this)
    this.handleDropdownSelect = this.handleDropdownSelect.bind(this)
    this.handleSelectSearchRequest = this.handleSelectSearchRequest.bind(this)
    this.apply = this.apply.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
  }

  componentWillMount () {
    const { searchRequests } = this.state
    let citiesIds = []
    let countriesIds = []
    let continentIds = []

    searchRequests &&
      searchRequests.forEach(searchRequest => {
        citiesIds = R.union(
          citiesIds,
          searchRequest.city ? [ searchRequest.city ] : []
        )
        countriesIds = R.union(
          countriesIds,
          searchRequest.country ? [ searchRequest.country ] : []
        )
        continentIds = R.union(
          continentIds,
          searchRequest.continent ? [ searchRequest.continent ] : []
        )
      })

    Promise.all([
      searchCategories(),
      continentIds.length > 0
        ? searchContinents({ where: { id: continentIds } })
        : [],
      countriesIds.length > 0
        ? searchCountries({ where: { id: countriesIds } })
        : [],
      citiesIds.length > 0 ? searchCities({ where: { id: citiesIds } }) : []
    ])
      .spread(
        (
          categoriesResponse,
          continentsResponse,
          countriesResponse,
          citiesResponse
        ) => {
          let categories = categoriesResponse.data

          if (searchRequests) {
            let categoriesHash = {}
            let continentsHash = {}
            let countriesHash = {}
            let citiesHash = {}

            categories &&
              categories.forEach(category => {
                categoriesHash[category.id] = category
              })

            continentsResponse.data &&
              continentsResponse.data.forEach(continent => {
                continentsHash[continent.id] = continent
              })

            countriesResponse.data &&
              countriesResponse.data.forEach(country => {
                countriesHash[country.id] = country
              })

            citiesResponse.data &&
              citiesResponse.data.forEach(city => {
                citiesHash[city.id] = city
              })

            searchRequests.forEach(search => {
              search.city = search.city && citiesHash[search.city]
              search.country = search.country && countriesHash[search.country]
              search.continent =
                search.continent && continentsHash[search.continent]
              search.category = categoriesHash[search.category]
            })
          }
          this.setState({ searchRequests, categories })
        }
      )
      .catch(console.error)
  }

  handleSearch (key, search) {
    switch (key) {
      case 'country':
        searchCountries({ where: { name: { startsWith: search } } })
          .then(response => {
            this.setState({ searchCountry: search, countries: response.data })
          })
          .catch(console.error)
        break
      case 'continent':
        searchContinents({ where: { name: { startsWith: search } } })
          .then(response => {
            this.setState({
              searchContinent: search,
              continents: response.data
            })
          })
          .catch(console.error)
        break
      case 'city':
        searchCities({ where: { city: { startsWith: search } } })
          .then(response => {
            this.setState({ searchCity: search, cities: response.data })
          })
          .catch(console.error)
        break
      default:
    }
  }

  handleSelect (key, value) {
    const { settings } = this.state
    settings[key] = addOrRemoveObjectFromList(settings[key], value)
    this.setState({
      settings,
      searchCountry: '',
      searchCategory: '',
      searchContinent: '',
      searchCity: ''
    })
  }

  handleRange (minKey, maxKey, value) {
    const { settings } = this.state
    settings[minKey] = value.min
    settings[maxKey] = value.max
    this.setState({ settings })
  }

  handleDropdownClick (id) {
    if (this.state.active === id) {
      return this.setState({ active: '' })
    }
    this.setState({ active: id })
  }

  handleDropdownSelect (key, el) {
    const { settings } = this.state
    settings[key] = el
    this.setState({ settings })
  }

  handleSelectSearchRequest (searchRequest) {
    let settings = {
      minInvestment: searchRequest.minPrice,
      maxInvestment: searchRequest.maxPrice || maxPrice,
      minNoRooms: searchRequest.minNoRooms,
      maxNoRooms: searchRequest.maxNoRooms || maxRooms,
      minYield: searchRequest.minYield,
      maxYield: searchRequest.maxYield || maxYield,
      preferredCategories: searchRequest.category
        ? [ searchRequest.category ]
        : [],
      preferredCities: searchRequest.city ? [ searchRequest.city ] : [],
      preferredCountries: searchRequest.country
        ? [ searchRequest.country ]
        : [],
      preferredRegions: searchRequest.continent
        ? [ searchRequest.continent ]
        : []
    }
    this.setState({ settings, selectedRequest: searchRequest }, () =>
      this.apply()
    )
  }

  handleOnBlur () {
    this.timer = setTimeout(() => {
      this.setState({
        active: '',
        searchCountry: '',
        searchCategory: '',
        searchContinent: '',
        searchCity: ''
      })
    }, 0)
  }

  handleOnFocus () {
    clearTimeout(this.timer)
  }

  clearFilters () {
    this.setState(
      {
        settings: R.clone(searchQueryDefault),
        favorites: null,
        portfolio: null,
        searchCountry: '',
        active: '',
        searchCategory: '',
        searchContinent: '',
        searchCity: '',
        selectedRequest: null,
        openModal: false
      },
      () => this.props.updateSettings(searchQueryDefault)
    )
  }

  apply () {
    const { updateSettings } = this.props
    if (updateSettings) {
      this.setState(
        {
          active: '',
          searchCountry: '',
          searchCategory: '',
          searchContinent: '',
          searchCity: '',
          openModal: false
        },
        () => updateSettings(this.state.settings)
      )
    }
  }

  toggleModal () {
    this.setState({ openModal: !this.state.openModal })
  }

  render () {
    let {
      active,
      settings,
      categories,
      continents,
      countries,
      cities,
      searchCategory,
      searchContinent,
      searchCountry,
      searchCity,
      selectedRequest,
      openModal,
      searchRequests
    } = this.state
    const { isAdminPage, exportAction, t, isAdmin } = this.props
    return (
      <Container>
        <MobileSearchBar
          openModal={openModal}
          toggleModal={this.toggleModal}
          apply={this.apply}
          clearFilters={this.clearFilters}
          isAdmin={isAdmin}>
          {searchRequests && (
            <Form>
              <Title>{t('Search Requests')}</Title>
              <Dropdown
                id={'mobile'}
                options={searchRequests}
                accessor={d => d.name}
                selectedOption={selectedRequest}
                handleSelect={this.handleSelectSearchRequest}
                placeholder={'Select Search Request'}
              />
            </Form>
          )}
          <Form>
            <Title>{t('Type of Asset')}</Title>
            <MultiSelectDropdown
              options={categories}
              showTags
              selectedOptions={settings.preferredCategories}
              value={searchCategory}
              handleSelect={value => {
                this.handleSelect('preferredCategories', value)
              }}
              placeholder={'Filter By Type of Asset'}
              accessor={d => d.name}
              tagsAccessor={d => d.name}
            />
          </Form>

          <Form>
            <Title>{t('Continent')}</Title>
            <SearchableDropdown
              showTags
              selectedOptions={settings.preferredRegions}
              options={continents}
              value={searchContinent}
              handleSearch={event => {
                this.handleSearch('continent', event.target.value)
              }}
              handleSelect={value => {
                this.handleSelect('preferredRegions', value)
              }}
              placeholder={'Filter By Continent'}
              accessor={d => d.name}
              tagsAccessor={d => d.name}
            />
          </Form>

          <Form>
            <Title>{t('Country')}</Title>
            <SearchableDropdown
              options={countries}
              selectedOptions={settings.preferredCountries}
              showTags
              value={searchCountry}
              handleSearch={event => {
                this.handleSearch('country', event.target.value)
              }}
              handleSelect={value => {
                this.handleSelect('preferredCountries', value)
              }}
              placeholder={'Filter By Country'}
              accessor={d => d.name}
              tagsAccessor={d => d.name}
            />
          </Form>

          <Form>
            <Title>{t('City')}</Title>
            <SearchableDropdown
              options={cities}
              value={searchCity}
              showTags
              selectedOptions={settings.preferredCities}
              handleSearch={event => {
                this.handleSearch('city', event.target.value)
              }}
              handleSelect={value => {
                this.handleSelect('preferredCities', value)
              }}
              placeholder={'Filter By Metropolitan Area'}
              accessor={d => d.city}
              tagsAccessor={d => d.city}
            />
          </Form>

          <Form>
            <Title>{t('Portfolio')}</Title>
            <Dropdown
              options={[ true, false ]}
              accessor={d => (d ? 'Yes' : 'No')}
              selectedOption={settings.portfolio}
              handleSelect={el => this.handleDropdownSelect('portfolio', el)}
              placeholder={'Filter By Portfolio'}
            />
          </Form>
          <Form>
            <Title>{t('Number of Keys')}</Title>
            <RangePicker
              max={maxRooms}
              step={defaultRoomsStep}
              minValue={settings.minNoRooms}
              maxValue={settings.maxNoRooms}
              handleChange={value =>
                this.handleRange('minNoRooms', 'maxNoRooms', value)}
            />
          </Form>

          <Form>
            <Title>{t('Price')}</Title>
            <RangePicker
              max={maxPrice}
              step={defaultPriceStep}
              minValue={settings.minInvestment}
              maxValue={settings.maxInvestment}
              unit={'€'}
              handleChange={value =>
                this.handleRange('minInvestment', 'maxInvestment', value)}
            />
          </Form>

          <Form>
            <Title>{t('Estimated Yield')}</Title>
            <RangePicker
              max={maxYield}
              step={defaultYieldStep}
              minValue={settings.minYield}
              maxValue={settings.maxYield}
              unit={'%'}
              rightUnit
              handleChange={value =>
                this.handleRange('minYield', 'maxYield', value)}
            />
          </Form>
        </MobileSearchBar>
        <SearchBarContainer className='searchbar-container' isAdmin={isAdmin}>
          {searchRequests && (
            <SearchDropdown
              id={'Search Requests'}
              dropdown
              active={active}
              onFocus={this.handleOnFocus}
              onBlur={this.handleOnBlur}
              onClick={this.handleDropdownClick}>
              <CustomDropdown
                id={'desktop'}
                options={searchRequests}
                accessor={d => d.name}
                selectedOption={selectedRequest}
                handleSelect={this.handleSelectSearchRequest}
                placeholder={'Select Search Request'}
              />
            </SearchDropdown>
          )}

          <SearchDropdown
            id={'Type of Asset'}
            active={active}
            dropdown
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onClick={this.handleDropdownClick}>
            <CustomMultiSelect
              options={categories}
              showTags
              selectedOptions={settings.preferredCategories}
              value={searchCategory}
              handleSelect={value => {
                this.handleSelect('preferredCategories', value)
              }}
              placeholder={'Filter By Type of Asset'}
              accessor={d => d.name}
              tagsAccessor={d => d.name}
            />
            <ButtonContainer>
              <Button onClick={this.apply} label={'Apply'} />
            </ButtonContainer>
          </SearchDropdown>
          <SearchDropdown
            id={'Country'}
            active={active}
            dropdown
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onClick={this.handleDropdownClick}>
            <CustomSearchableDropdown
              value={this.state.searchCountry}
              handleSearch={event => {
                this.handleSearch('country', event.target.value)
              }}
              placeholder='Type the country name'
              options={this.state.countries}
              showTags
              selectedOptions={settings.preferredCountries}
              handleSelect={value =>
                this.handleSelect('preferredCountries', value)}
              className='search'
              accessor={d => d.name}
              tagsAccessor={d => d.name}
            />
            <ButtonContainer>
              <Button onClick={this.apply} label={'Apply'} />
            </ButtonContainer>
          </SearchDropdown>
          <SearchDropdown
            id={'Price'}
            active={active}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onClick={this.handleDropdownClick}>
            <CustomRangePicker
              key='investment'
              max={maxPrice}
              step={defaultPriceStep}
              minValue={settings.minInvestment}
              maxValue={settings.maxInvestment}
              unit={'€'}
              handleChange={value =>
                this.handleRange('minInvestment', 'maxInvestment', value)}
            />
            <ButtonContainer noPadding>
              <Button onClick={this.apply} label={'Apply'} />
            </ButtonContainer>
          </SearchDropdown>
          <SearchDropdown
            id={'Estimated Yield'}
            active={active}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onClick={this.handleDropdownClick}>
            <CustomRangePicker
              key='Yield'
              minValue={settings.minYield}
              maxValue={settings.maxYield}
              unit={'%'}
              rightUnit
              handleChange={value =>
                this.handleRange('minYield', 'maxYield', value)}
              max={maxYield}
            />
            <ButtonContainer noPadding>
              <Button onClick={this.apply} label={'Apply'} />
            </ButtonContainer>
          </SearchDropdown>
          <SearchDropdown
            id={'More Filters'}
            active={active}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onClick={this.handleDropdownClick}>
            <MoreFilters
              t={t}
              clearFilters={this.clearFilters}
              handleSelect={this.handleSelect}
              settings={settings}
              categories={categories}
              handleDropdownSelect={this.handleDropdownSelect}
              handleRange={this.handleRange}
              apply={this.apply}
              isAdminPage={isAdminPage}
            />
          </SearchDropdown>
          <ActionsContainer>
            {exportAction && (
              <ExportInfo
                secondary
                onClick={exportAction}
                label={t('Export to Excel')}
              />
            )}
          </ActionsContainer>
        </SearchBarContainer>
      </Container>
    )
  }
}

SearchBar.propTypes = {
  updateSettings: PropTypes.func,
  settings: PropTypes.object,
  isAdminPage: PropTypes.bool,
  exportAction: PropTypes.func,
  t: PropTypes.func,
  isAdmin: PropTypes.bool,
  searchRequests: PropTypes.array
}

export default translate([ 'common', 'search', 'forms' ], { wait: true })(
  SearchBar
)



// WEBPACK FOOTER //
// ./src/components/SearchBar/index.js